import RouteManager from './route.manager';
 
export default class ExtendRouteManager extends RouteManager {

    protected _dynamicElsQueries           : Array<string> = ['main', '.hero_main', 'footer', 'header .nav_main', 'main .nav_main']; 
    
    protected _onBeforeUpdate(url) {
        TweenMax.killAll();
        TweenMax.to(document.body, 0.4, {opacity:0,
            onComplete:()=> {
                super._onBeforeUpdate(url);
            }
        });
    }

    protected _onUpdate(e) {
        super._onUpdate(e);
        TweenMax.to(document.body, 0.4, {opacity:1});
    }
}